/** The wash laid over a Handwerker who does not cover the Gewerk being planned. One place to tune it. */
export const MUTED_TINT = 'bg-slate-200/60';
